<template>
  <div class="">
    <h3>بخش زمان بندی</h3>

    <select class="custom-select my-3" v-model="selectedReservationRuleMode" @change="changeReservationRule()">
      <option value="">نوع زمان بندی را انتخاب کنید.</option>
      <option value="day">روزانه</option>
      <option value="hour">ساعتی</option>
    </select>

    <reservation-day
        v-if="selectedReservationRuleMode === 'day'"
        :reservation="reservation"
    />

    <reservation-hour
        v-if="selectedReservationRuleMode === 'hour'"
        :reservation="reservation"
    />

    <div class="text-left">
      <div @click="updateReservationRule(reservationRule)" class="btn btn-primary my-4 mx-2 rounded-pill ">
        ذخیره تنظیمات
      </div>
      <div @click="updateReservationRule(reservationRule,true)" class="btn btn-secondary my-4 mx-2 rounded-pill ">
        تست ساعت ها
      </div>
    </div>

  </div>
</template>

<script>
import ReservationDay from "./day/ReservationDay.vue";
import {
  createNestedObject,
  reservationModeObjects
} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Reservation'
import ReservationHour from "./hour/ReservationHour.vue";

const traverseAndFlatten = (currentNode, target, flattenedKey) => {
  for (var key in currentNode) {
    if (currentNode.hasOwnProperty(key)) {
      var newKey;
      if (flattenedKey === undefined) {
        newKey = key;
      } else {
        newKey = flattenedKey + '.' + key;
      }

      var value = currentNode[key];
      if (typeof value === "object") {
        traverseAndFlatten(value, target, newKey);
      } else {
        target[newKey] = value;
      }
    }
  }
}


const flatten = (obj) => {
  var flattenedObject = {};
  traverseAndFlatten(obj, flattenedObject);
  return flattenedObject;
}

export default {
  name: "Reservation",
  components: {ReservationHour, ReservationDay,},
  props: {
    reservationRule: {},
    reservationTimes: {},
    product: {}
  },
  data() {
    return {
      selectedReservationRuleMode: '',
      reservationModeObjects,
    }
  },
  computed: {
    reservationRuleMode() {
      return this.reservationRule.reservation_mode
    },
    reservation() {
      let reservationRule = this.reservationRule
      let reservationTimes = this.reservationTimes
      let product = this.product
      return {
        reservationRule,
        reservationTimes,
        product
      }
    }
  },
  methods: {
    /*
    * add new key item to reservation object base on reservationModeObjects in module.
    * */
    setupReservationRules(reservationMode) {
      let originalTranslations = flatten(Object.assign({}, reservationModeObjects))

      let translations = this.$store.getters['Reservation/getReservationRule']
      let siteTranslation = flatten(translations)

      // loop on originalTranslations item
      Object.entries(originalTranslations).forEach((originalTranslate) => {
        const key = originalTranslate[0]
        const value = originalTranslate[1]
        // compare site translation item with original
        if (Object.keys(siteTranslation).indexOf(key) === -1) {
          // if new item not exist on translation we set it with default value of original translation
          createNestedObject(translations, key.split('.'), value)
        }

      })

      // define the keys array
      var keys = Object.entries(reservationModeObjects);
      // loop through the keys and assign an empty array if not in rulesJson
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i][0];
        var value = keys[i][1];
        if (!translations.hasOwnProperty(key)) {
          if (['extra_items', 'work_times', 'off_times'].indexOf(key) > -1) {
            translations[key] = []
            if (key === 'work_times') {

              translations[key] = [
                [],
                [],
                [],
                [],
                [],
                [],
                [],
              ]

            }

          } else {
            translations[key] = value
          }
        }
      }


      // set reservation mode
      translations.reservation_mode = reservationMode

    },
    changeReservationRule() {
      this.setupReservationRules(this.selectedReservationRuleMode)
    },
    async updateReservationRule(reservationRule, test = false) {
      let rules = JSON.stringify(reservationRule);
      let month = this.$store.getters['Reservation/getMonth'];
      const year = this.$store.getters['Reservation/getYear']

      const form = {
        json: rules,
        product: this.reservation.product
      }
      let reservationForm = {
        product: this.reservation.product,
        withoutState: test, // if we are in test we don't mutate reservation rules in generate state
        month: month,
        year: year,
      }

      if (!test) {
        await this.$store.dispatch('Reservation/updateReservationRule', form)
      } else {
        reservationForm['rules'] = rules
      }

      let DashboardProductRules = await this.$store.dispatch("Reservation/getDashboardProductRules", reservationForm);
      let reservationTimes = DashboardProductRules.data.data.reservation_times
      this.$store.commit('Reservation/setReservationTimes', reservationTimes)


    },
  },
  mounted() {
    if (this.selectedReservationRuleMode !== '') {
      this.setupReservationRules(this.selectedReservationRuleMode)
    }
  },
  watch: {
    reservationRuleMode(newValue) {
      console.log(newValue)
      if (newValue != undefined) {
        this.selectedReservationRuleMode = newValue
      }
    }
  }
}
</script>


<style scoped>

</style>